<template>
    <aside :class="{ 'toggled': isToggled }">
        <div class="sidebar-profile" v-if="currentUser">
            <div class="profile-image">
                <a href="javascript:;" class="password-to-change" v-if="currentUser.firstLogin"
                    title="ATTENZIONE! Password da cambiare">
                    <font-awesome-icon class="text-danger" icon="exclamation-triangle"></font-awesome-icon>
                </a>
                <div class="circular" v-bind:style="{ backgroundImage: `url(${profileImage})` }"></div>
            </div>
            <span class="online-status online"></span>
            <div class="profile-name">
                <p class="name">{{ currentUser.username }} <br> {{ currentUser.email }}</p>
                <p class="designation"><span v-if="currentUser.type === 1">Admin</span><span v-else>Utente</span></p>
                <!-- <div class="badge badge-success mx-auto mt-3">Online</div> -->
            </div>
        </div>
        <ul class="sidebar navbar-nav">
            <li class="nav-item">
                <router-link class="nav-link" to="/" exact>
                    <font-awesome-icon icon="home" /> <span>Home</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/missions">
                    <font-awesome-icon icon="project-diagram" /> <span>Missioni</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/articles">
                    <font-awesome-icon icon="newspaper" /> <span>News</span>
                </router-link>
            </li>
            <li class="nav-item" v-if="currentUser.type === 1">
                <router-link class="nav-link" to="/users">
                    <font-awesome-icon icon="users" /> <span>Utenti</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/documents">
                    <font-awesome-icon :icon="['far', 'folder-open']" /> <span>Documenti</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/messages">
                    <font-awesome-icon :icon="['far', 'comments']" /> <span>Messaggi (beta)</span>
                </router-link>
            </li>
            <li class="nav-item" v-if="currentUser.type === 1">
                <router-link class="nav-link" to="/survey">
                    <font-awesome-icon icon="poll-h" /> <span>Survey</span>
                </router-link>
            </li>
        </ul>
        <span class="d-block version text-muted">
            v. <span class="text-uppercase">{{ version }}</span>
        </span>
    </aside>
</template>
<script>
import {
    mapState,
    mapGetters
} from 'vuex'
export default {
    name: 'side-bar',
    computed: {
        ...mapGetters([
            'isAuthenticated',
            'currentUser'
        ]),
        ...mapState([
            'isToggled'
        ]),
        profileImage () {
            return this.currentUser.image || require('@/assets/images/default.png')
        },
        version () {
            return `AIG-${process.env.VUE_APP_BRANCH}-${process.env.VUE_APP_VERSION}`
        }
    }
}
</script>
